import React, { useContext } from "react";
import { RicosNodeContext, RicosNodeContextProvider } from "./../../ricos-context";
const TableRow = ({ node, nodeIndex, RicosNodesRenderer }) => {
  const { parentNode } = useContext(RicosNodeContext);
  const style = { height: parentNode?.tableData?.dimensions?.rowsHeight?.[nodeIndex] || "auto" };
  return /* @__PURE__ */ React.createElement("tr", { style }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes ?? [] })));
};
const TableRowRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(TableRow, { key: node.id, node, ...props });
};
var tableRow_default = TableRowRenderer;
export {
  tableRow_default as default
};
//# sourceMappingURL=tableRow.js.map
